import AcknowledgmentEmail from './AcknowledgmentEmail';

export default AcknowledgmentEmail;
